import React from 'react';
import '../components/Tab.css';
import Box from '../components/Box';
import useCourses from '../hooks/useCourses';
import { useBooking } from '../BookingProvider';
import { useHistory } from '../hooks/useParams';
import FullPageSpinner from '../components/FullPageSpinner';
import CourseListViewItem from '../components/CourseListViewItem';

export default () => {
  const history = useHistory();
  const { addCourse } = useBooking();

  const [isLoadingCourses, courses] = useCourses("DrivingAttendant");

  const setupOnCourseClick = (course) => () => {
    if (course.freePlaces === 0) return;
    addCourse(course);
    history.push('/fahrbegleiterkurs/booking');
  };

  if (isLoadingCourses) return <FullPageSpinner />
  if (!courses) return null;

  return (
    <Box>
      <Box>
        {
          courses.map(
            course =>
              <CourseListViewItem
                key={course._id}
                course={course}
                onClick={setupOnCourseClick(course)}
              />
          )
        }
      </Box>
    </Box>
  );
}
